import React from 'react';
import { Switch, Route } from 'react-router';
import { useSelector } from 'react-redux';

import RouteGetter from '../../../routes/RouteGetter';
import ProjectEdit from './ProjectEdit';
import { selectCurrentUser } from '../../../store/modules/users/selectors';

const TabAdmin = () => {
  const { data } = useSelector(selectCurrentUser);

  if (data === null || !data.is_super_admin) {
    return null;
  }

  return (
    <Switch>
      <Route exact path={RouteGetter.get('project').adminPath()}>
        <ProjectEdit />
      </Route>
    </Switch>
  );
};

export default TabAdmin;
